import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/coupon-usage"

export const getCouponUsedList = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })


  const response = await farasod.get(`${endpoint}/history?${query}`)

  return response.data
}

export const getReportCouponUsed = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/report/used?${query}`)

  return response.data
}